import { buildTitilliumFontFace } from '@mss_creator/shared';
import boldUrl from '../../../../shared/assets/fonts/TitilliumWeb-Bold.ttf?url';
import italicUrl from '../../../../shared/assets/fonts/TitilliumWeb-Italic.ttf?url';
import regularUrl from '../../../../shared/assets/fonts/TitilliumWeb-Regular.ttf?url';
import semiBoldUrl from '../../../../shared/assets/fonts/TitilliumWeb-SemiBold.ttf?url';

/**
 * The preview's `@font-face` block — the browser half of decision F2
 * (2026-08-25 doc).
 *
 * `?url` imports rather than a hardcoded `/fonts/…` path because the faces now
 * live in `packages/shared/assets/fonts` (shared with the backend, which
 * embeds them as base64) and Vite emits them as hashed build assets. Asking
 * Vite for the resolved URL is therefore the only way to get a path that is
 * correct in both dev and production.
 *
 * Only URLs enter the JS bundle — the font bytes themselves stay separate
 * cacheable assets, unlike the backend's base64 form, which has to embed them
 * because Playwright renders on `about:blank` where no path resolves.
 */
export const EXPORT_FONT_FACE_CSS = buildTitilliumFontFace({
  'TitilliumWeb-Regular.ttf': regularUrl,
  'TitilliumWeb-Italic.ttf': italicUrl,
  'TitilliumWeb-SemiBold.ttf': semiBoldUrl,
  'TitilliumWeb-Bold.ttf': boldUrl,
});
